import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Typography, Input, Row, Col, Spin, Button } from "antd";
import "@google/model-viewer/dist/model-viewer";
import axios from "axios";
import envConfig from "../config.json";
import ModelUpload from "../components/ModelUpload";
import ListModel from "../components/ListModel";
import { searchStyle } from "../StyleObj";
import { useTheme } from "./ThemeContext";

const { Search } = Input;
const AUTH_ERROR = 401;
/**
 * Component to handle Coupled(3DCE) model
 */
const CoupleModel = () => {
  const { instance } = useMsal();
  const { Title } = Typography;
  const [showProgress, setShowProgress] = useState(false);
  const [assetId, setAssetId] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [models3DCE, setModels3DCE] = useState([]);
  const [loadMore, setLoadMore] = useState(false);
  const [searchText, setSearchText] = useState("");
  const { theme } = useTheme();

  const msalToken = localStorage.getItem("msal.accesstoken");

  /**
   * This arrow function used to handle the error
   */
  const handleError = (error) => {
    console.error("Error: " + error);
    if (error.response.status === AUTH_ERROR) {
      localStorage.removeItem("checkRole");
      const logoutRequest = {
        postLogoutRedirectUri: envConfig.redirectUri,
      };
      instance.logoutRedirect(logoutRequest);
    }
  };
  /**
   * This arrow function used to fetch the token
   */
  const fetch3DCEtoken = async () => {
    setShowProgress(true);
    const getConfig = {
      headers: { Authorization: `Bearer ${msalToken}` },
    };
    await axios
      .get(`${envConfig.aotmwapi}/api/3d-cms/continuumengine/login`, getConfig)
      .then((res) => {
        localStorage.setItem("accesstokence", res.data.accessToken);
        fetch3DCEModels();
      })
      .catch((error) => {
        handleError(error);
      });
  };
  /**
   * This arrow function used to filter the models for couple(3DCE) application type
   */
  const filter3DCEModels = (value, _e) => {
    setShowProgress(true);
    setSearchText(value);
    setAssetId("");
    models3DCE.length = 0;
    setModels3DCE([]);
    if (value) {
      fetch3DCEModelsLoadMore(value, true);
    } else {
      fetch3DCEModels();
    }
  };

  /**
   * This arrow function used to fetch the models for couple(3DCE) application type
   */
  const fetch3DCEModels = async () => {
    setShowProgress(true);
    const Token3DCE = localStorage.getItem("accesstokence");
    const config = {
      headers: {
        Authorization: `Bearer ${msalToken}`,
        authorization_token: Token3DCE,
      },
    };
    axios
      .get(`${envConfig.aotmwapi}/api/3d-cms/continuumengine`, config)
      .then((response) => {
        setShowProgress(false);
        setModels3DCE(response.data.data);
        if (response.data.lastRead.assetId) {
          setLoadMore(true);
          setAssetId(response.data.lastRead.assetId);
          setUpdatedAt(response.data.lastRead.updatedAt);
        } else {
          setLoadMore(false);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  /**
   * This arrow function used to fetch the models on loadmore or filter icon click for couple(3DCE) application type
   */
  const fetch3DCEModelsLoadMore = async (title, isInitialSearch = false) => {
    setShowProgress(true);
    const searchedText = searchText || (title?.length ? title : "");
    fetch3DCEModelsLoadMoreWitoutTitle(searchedText, isInitialSearch);
  };

  /**
   * This arrow function used to fetch the models on loadmore or filter icon click for couple(3DCE) application type when there is no title search
   */
  const fetch3DCEModelsLoadMoreWitoutTitle = async (
    searchedText,
    isInitialSearch = false
  ) => {
    const Token3DCE = localStorage.getItem("accesstokence");
    let url = `${envConfig.aotmwapi}/api/3d-cms/continuumengine`;
    if (assetId && !isInitialSearch) {
      url = !searchedText?.length
        ? `${envConfig.aotmwapi}/api/3d-cms/continuumengine?lastReadAssetId=${assetId}&lastReadUpdatedAt=${updatedAt}`
        : `${envConfig.aotmwapi}/api/3d-cms/continuumengine?lastReadAssetId=${assetId}&lastReadUpdatedAt=${updatedAt}&searchText=${searchedText}`;
    } else if (searchedText?.length) {
      url = `${envConfig.aotmwapi}/api/3d-cms/continuumengine?searchText=${searchedText}`;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${msalToken}`,
        authorization_token: Token3DCE,
      },
    };
    axios
      .get(url, config)
      .then(function (response) {
        setShowProgress(false);
        if (models3DCE.length === 0) {
          setModels3DCE(response.data.data);
        } else {
          setModels3DCE([...models3DCE, ...response.data.data]);
        }
        if (response.data.lastRead.assetId != null) {
          setLoadMore(true);
          setAssetId(response.data.lastRead.assetId);
          setUpdatedAt(response.data.lastRead.updatedAt);
        } else {
          setLoadMore(false);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };
  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    fetch3DCEtoken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="containerFixed">
        <Row className="paddingRow">
          <Col span={12}>
            <div className="divAlignLeft">
              <Title>Model</Title>
            </div>
          </Col>
          <Col span={12}>
            <div className="assetUploadTop">
              <ModelUpload fetchModels={fetch3DCEModels} />
            </div>
          </Col>
        </Row>
        <Row className="paddingRow">
          <Col span={12}>
            <div className="divAlignLeft">
            </div>
          </Col>
          <Col span={12}>
            <div className="divAlignRight">
              <Search
                placeholder="Model Search(case-sensitive)"
                allowClear
                onChange={(e) => setSearchText(e.target.value)}
                bordered={false}
                onSearch={(value, event) => filter3DCEModels(value, event)}
                style={searchStyle(theme)}
              />
            </div>
          </Col>
        </Row>

        <br />
        <div>
          <Spin spinning={showProgress}>
            <div id="content-scroll" className="listContainer">
              <ListModel
                models={models3DCE}
                fetchModels={fetch3DCEModels}
                page="3dce"
              />
              {loadMore ? (
                <div className="divAlignCenter">
                  <Button
                    className="builderButton"
                    onClick={fetch3DCEModelsLoadMore}
                  >
                    Load More
                  </Button>
                </div>
              ) : null}
              <br></br>
              <br></br>
            </div>
          </Spin>
        </div>
      </div>
  );
};

export default CoupleModel;
